import lity from "lity"

const VideoPopup = {
  init: function() {
    const links = document.querySelectorAll('[data-lity]')

    if (!links) return

    links.forEach(link => link.addEventListener('click', () => lity))
  }
}

export default VideoPopup
